import axios from 'axios'

const request = axios.create({
	timeout: 60000 * 3,
})

request.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token') || '';
		if (token) {
			config.headers['X-Access-Token'] = token
		}
		return config
	},
	error => Promise.reject(error),
)
request.interceptors.response.use(
	response => {
		if (!response.data.code || response.data.code === 200) {
			// console.log(response)
			return response.data.data
		} else if (response.data.code === 401) {
			const currentUrl = window.location.pathname || ''
			if (!currentUrl.includes('/login')) {
				localStorage.clear();
				window.location.replace('/login')
			}
		}
		const error = handleError(response)
		return Promise.reject(error)
	},
	error => {
		return Promise.reject(error)
	},
)

function handleError(error) {
	let { data, status, message } = error
	return {
		code: data ? data.code : status,
		message: data ? data.msg : message,
	}
}

export default request
